"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const Button_1 = __importDefault(require("../../common/js/atoms/Button"));
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const ButtonVariant_1 = __importDefault(require("../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const translation_1 = require("../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const LicenseStore_1 = __importDefault(require("../stores/LicenseStore"));
class SoftwareDownloadLicenseModal extends react_1.default.Component {
    downloadNowDeactivated = true;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            downloadNowDeactivated: mobx_1.observable,
        });
    }
    render() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "modal-header znd-modal__header" },
                react_1.default.createElement("h3", { className: "znd-modal__title" }, (0, translation_1.t)('modal.software_download_license.title', { channel: AuthorizationStore_1.default.channelId })),
                react_1.default.createElement("div", { className: "znd-modal__close", onClick: this.props.onCancel },
                    react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.close }))),
            react_1.default.createElement("div", { className: "modal-body znd-modal__body" },
                react_1.default.createElement("div", { className: "znd-software-license-modal__text", dangerouslySetInnerHTML: {
                        __html: (0, translation_1.t)('modal.software_download_license.text', {
                            channel: AuthorizationStore_1.default.channelId,
                        }),
                    } }),
                react_1.default.createElement("label", { className: "custom-control custom-checkbox znd-software-license-modal__checkbox-label" },
                    react_1.default.createElement("input", { type: "checkbox", className: "custom-control-input", onChange: (event) => {
                            this.downloadNowDeactivated = !event.target.checked;
                        } }),
                    react_1.default.createElement("span", { className: "custom-control-label", dangerouslySetInnerHTML: {
                            __html: (0, translation_1.t)('modal.software_download_license.label', {
                                channel: AuthorizationStore_1.default.channelId,
                            }),
                        } }))),
            react_1.default.createElement("div", { className: "modal-footer znd-modal__footer" },
                react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.secondary, text: (0, translation_1.t)('message_modal.cancel'), onClick: this.props.onCancel }),
                react_1.default.createElement(Button_1.default, { className: "znd-software-license-modal__button", variant: ButtonVariant_1.default.primary, text: (0, translation_1.t)('modal.software_download_license.action', { channel: AuthorizationStore_1.default.channelId }), disabled: this.downloadNowDeactivated, onClick: () => {
                        LicenseStore_1.default.consentLicense(this.props.licenseId);
                        this.props.onDone(this.props.licenseId);
                    } }))));
    }
}
exports.default = (0, mobx_react_1.observer)(SoftwareDownloadLicenseModal);
